import { get, post } from '@/utils/request'

export interface ProjectAttachment {
  attachmentId: string
  projectId: string
  attachmentType: string
  attachmentTypeName: string
  fileId: string
  fileMd5: string
  fileName: string
  fileSize: number
  uploadUser: string
  uploadAt: string
}

export interface ProjectFinanceInvoiceItem {
  detailId: string
  itemName: string
  unitName: string
  buyerName?: string
  amount: number
  occurTime: string
  remark?: string
  receivableDetailId?: string
}

export interface ProjectFinanceReceivableItem {
  detailId: string
  itemName: string
  amount: number
  occurTime?: string | null
  remark?: string
  invoiceDetailId?: string
}

export interface ProjectFinanceExpenseItem {
  detailId: string
  itemName: string
  amount: number
  occurTime: string
  remark?: string
}

export interface ProjectFinanceDetail {
  invoiceTotal: number
  receivableTotal: number
  expenseTotal: number
  invoiceItems: ProjectFinanceInvoiceItem[]
  receivableItems: ProjectFinanceReceivableItem[]
  expenseItems: ProjectFinanceExpenseItem[]
}

// 新建项目
export const getCloudProjectList = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/list', data)
// 项目列表
export const getCloudProjectList2 = (data: any) =>
  // post<any>('/cost-cloud-cloudproject/cloudproject/list2', data)
  post<any>('/cost-cloud-cloudproject/cloudproject/list2-with-finance', data)

// 查询符合条件的工程数量
export const getCloudProjectCount = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/count2', data)

// 新建项目
export const createCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/add', data)

// 展示当前租户的字段显示设置信息
export const getCloudProjectColumns = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/show_properties/list', data)

// 展示当前租户的字段显示设置信息
export const modifyCloudProjectColumns = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/show_properties/modify', data)

// 展示当前租户的字段显示设置信息
export const archiveCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/archive', data)

// 修改项目所属组织结构
export const modifyCloudProjectAscription = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/ascription/modify', data)

// 编辑云工程
export const editCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/modify', data)

// 修订云工程
export const reviseCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/revise', data)

// 项目审批
export const approveCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/approve', data)

// 审批驳回项目重新提交审批
export const reapproveCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/reapprove', data)

export interface CloudProjectLatestApproveParams {
  tenantId: string
  projectId: string
}

export interface CloudProjectLatestApproveResult {
  id?: string | number
  projectId?: string
  tenantId?: string
  approveResult?: number
  approveOpinion?: string
  errorProperties?: string
  projectCode?: string
  approveTime?: string
  approver?: string
  createdBy?: string
  createdAt?: string
  updatedBy?: string
  updatedAt?: string
  isDeleted?: number
  [key: string]: any
}

export const getCloudProjectLatestApproveResult = (data: CloudProjectLatestApproveParams) =>
  post<CloudProjectLatestApproveResult>(
    '/cost-cloud-cloudproject/cloudproject/latest-approve-result',
    data,
  )

// 生成项目编号
export const generateProjectCode = (projectId: string) =>
  get<string>('/cost-cloud-cloudproject/cloudproject/generate_project_code', { projectId })

// 生成项目预览编号（不落库）
export const generateProjectPreviewCode = (data: any) =>
  get<string>('/cost-cloud-cloudproject/cloudproject/generate_project_preview_code', data)

// 项目取消
export const cancelCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/cancel', data)

// 展示当前租户的字段显示设置信息
export const deleteCloudProject = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/remove', data)

// 文件相关

// 文件列表
export const getCloudFileList = (data: any) => post<any>('/cost-cloud-cloudproject/file/list', data)

// 上传文件到指定文件目录下
export const uploadCloudFile = (data: any) =>
  post<any>('/cost-cloud-cloudproject/file/upload', data)

// 文件批量删除功能
export const deleteCloudFile = (data: any) =>
  post<any>('/cost-cloud-cloudproject/file/delete', data)

// 文件编辑功能
export const editCloudFile = (data: any) => post<any>('/cost-cloud-cloudproject/file/edit', data)

// 在指定目录下创建文件夹
export const createCloudProjectDir = (data: any) =>
  post<any>('/cost-cloud-cloudproject/file/mkdir', data)

// 云工程附件
export const uploadProjectAttachment = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_attachment/upload', data)

export const getProjectAttachmentList = (params: any) =>
  get<ProjectAttachment[]>('/cost-cloud-cloudproject/cloudproject_attachment/list', params)

export const removeProjectAttachment = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_attachment/remove', data)

// 分页查询云工程附件列表
export const getProjectAttachmentPageList = (params: any) =>
  post<ProjectAttachment[]>('/cost-cloud-cloudproject/cloudproject_attachment/search', params)

// 勾选下载（打包下载），按附件ID列表批量下载
export const downloadProjectAttachmentByIds = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_attachment/batch_download/by_ids', data)

// 全部下载（打包下载），按查询条件批量下载
export const downloadProjectAttachmentBySearch = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_attachment/batch_download/by_search', data)

// 查询批量下载任务状态
export const getProjectAttachmentDownLoadStatus = (params: any) =>
  get<any>('/cost-cloud-cloudproject/cloudproject_attachment/batch_download/status', params)

// 获取打包下载地址，下载批量打包文件
export const getProjectAttachmentDownLoadUrl = (params: any) =>
  get<any>('/cost-cloud-cloudproject/cloudproject_attachment/batch_download/download', params)

// 云工程财务
export const getProjectFinanceDetail = (params: any) =>
  get<ProjectFinanceDetail>('/cost-cloud-cloudproject/cloudproject_finance/detail', params)

export const addProjectFinanceRecord = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_finance/add', data)

export const updateProjectFinanceRecord = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_finance/update', data)

export const removeProjectFinanceRecord = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject_finance/remove', data)

// 取消归档
export const unArchive = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/unArchive', data)

// 字段相关配置

// 查询模板字段列表
export const getTemplateFieldLists = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/search_list', data)

// 批量添加自定义的模板字段
export const addTemplateFields = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/add', data)

// 删除模板字段分组信息
export const deleteTemplateFieldsGroup = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/classify/remove', data)

// 修改模板字段分组信息
export const updateFieldsGroup = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/classify/modify', data)

// 添加模板字段分组信息
export const addFieldsGroup = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/classify/add', data)

// 列出当前租户可用的模板字段分组信息
export const getFieldsGroup = (data: any) =>
  get<any>('/cost-cloud-cloudproject/field/classify/list', data)

// 查询当前租户可以访问的云工程字段信息
export const getProjectFields = (data: any) => get<any>('/cost-cloud-cloudproject/field/list', data)

// 查询当前租户的模板字段的排序信息
export const getFieldSortInfo = (data: any) =>
  get<any>('/cost-cloud-cloudproject/field/sortinfo', data)

// 批量删除自定义的模板字段
export const deleteFields = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/remove', data)

// 批量修改自定义的模板字段
export const batchUpdateFields = (data: any) =>
  post<any>('/cost-cloud-cloudproject/field/modify', data)

// 主体资源权限查询接口
export const getSubjectResourceAuth = (data: any) =>
  get<any>('/cmp-admin/auth_authorized/subject_resource_auth', data)

// 主体资源权限查询接口
export const getAllProjectProperties = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/properties_4_filter', data)

// 获取可作为查询条件的工程属性内容
export const getSearchProjectProperties = (data: any) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/properties_4_search', data)


// 导出
export const exportCloudProject = (data: any, config = {}) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/export2', data, config)
export const exportCloudProject3 = (data: any, config = {}) =>
  post<any>('/cost-cloud-cloudproject/cloudproject/export3', data, config)
// 列出上次导出的字段列表
export const getLastexportfields = () =>
  get<any>('/cost-cloud-cloudproject/cloudproject/lastexportfields')

// 记录打印次数
export const saveTransferFormPrintTimes = (projectId: string) =>
  get<string>('/cost-cloud-cloudproject/cloudproject/save_transfer_form_print_times', { projectId })

// 获取打印次数
export const getTransferFormPrintTimes = (projectId: string) =>
  get<number>('/cost-cloud-cloudproject/cloudproject/query_transfer_form_print_times', { projectId })

// 流转单相关接口

// 流转单DTO接口定义
export interface ProjectTransferFormDTO {
  id: number
  projectId: string
  tenantId: string
  transferFormNo: string
  projectName: string
  projectCode: string
  projectType: string
  projectTypeName: string
  projectStatus: string
  projectStatusName: string
  projectManager: string
  projectManagerName: string
  projectStartDate: string
  projectEndDate: string
  projectBudget: number
  projectDescription: string
  createTime: string
  createBy: string
  updateTime: string
  updateBy: string
  isDeleted: boolean
  [key: string]: any
}

// 根据项目ID查询流转单列表
export const getProjectTransferFormList = (projectId: string) =>
  get<ProjectTransferFormDTO[]>('/cost-cloud-cloudproject/project-transfer-form/list-by-project', { projectId })

// 根据流转单ID查询流转单详情
export const getProjectTransferFormDetail = (id: number) =>
  get<ProjectTransferFormDTO>('/cost-cloud-cloudproject/project-transfer-form/detail', { id })

// 生成流转单
export const generateProjectTransferForm = (projectId: string) =>
  post<number>('/cost-cloud-cloudproject/project-transfer-form/generate', { projectId })


// 查看项目流转单
export const getProjectTransferFormLatestByProject = (projectId: string) =>
  get<any>('/cost-cloud-cloudproject/project-transfer-form/latest-by-project', { projectId })

// 获取PDF预览路径
export const getProjectTransferFormPreviewUrl = (projectId: string) =>
  get<string>('/cost-cloud-cloudproject/project-transfer-form/preview-url', { projectId })


// 审阅接口
export const reviewDataProject = (data: any) =>
  post<any>('/cmp-doc/data-project/review', data)
